import React from "react";

function Footer() {

	return(
		<div>
			<footer id="footer">

    <div className="container py-4">

      <div className="social-links text-center  pt-md-0">
        <a href="#" className="twitter"><i className="bx bxl-twitter"></i></a>
        <a href="#" className="facebook"><i className="bx bxl-facebook"></i></a>
        <a href="#" className="instagram"><i className="bx bxl-instagram"></i></a>
        <a href="#" className="google-plus"><i className="bx bxl-skype"></i></a>
        <a href="https://www.linkedin.com/in/lakshay-joshi-b9298b201/" className="linkedin"><i className="bx bxl-linkedin"></i></a>
        </div>

      <h6 className="Copyright">&copy; Copyright <strong><span>CookR</span></strong>. </h6>
      

    </div>

  </footer>
		</div>
		)
}


export default Footer;